import React from "react";

/**
 * Uygulama genelinde bir render hatası olursa boş beyaz ekran yerine
 * kullanıcıya anlamlı bir mesaj + Yenile/WhatsApp/telefon gösterir.
 * (Inline stil kullanır; Tailwind/CSS yüklenmese bile çalışır.)
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    try {
      if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", "exception", {
          description: String(error && error.message ? error.message : error),
          fatal: true,
        });
      }
    } catch (e) {}
    // eslint-disable-next-line no-console
    console.error("Uygulama hatası:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "80vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
            textAlign: "center",
          }}
        >
          <div style={{ maxWidth: "480px" }}>
            <p style={{ color: "#ec4899", fontWeight: 700, letterSpacing: "1px", margin: 0 }}>
              AYSUN ŞEREMET
            </p>
            <h1 style={{ fontSize: "24px", margin: "10px 0 12px", color: "#111827" }}>
              Bir sorun oluştu
            </h1>
            <p style={{ color: "#4b5563", margin: "0 0 22px", lineHeight: 1.6 }}>
              Sayfa yüklenirken beklenmeyen bir hata oluştu. Lütfen sayfayı
              yenileyin; sorun sürerse WhatsApp veya telefon ile ulaşabilirsiniz.
            </p>
            <div style={{ display: "flex", gap: "10px", justifyContent: "center", flexWrap: "wrap" }}>
              <button
                onClick={() => window.location.reload()}
                style={{ background: "#111827", color: "#fff", border: "none", borderRadius: "9999px", padding: "11px 22px", fontWeight: 600, cursor: "pointer" }}
              >
                Sayfayı Yenile
              </button>
              <a
                href="https://wa.me/905372153407"
                style={{ background: "#22c55e", color: "#fff", borderRadius: "9999px", padding: "11px 22px", fontWeight: 600, textDecoration: "none" }}
              >
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905372153407"
                style={{ border: "1px solid #d1d5db", color: "#111827", borderRadius: "9999px", padding: "11px 22px", fontWeight: 600, textDecoration: "none" }}
              >
                0537 215 34 07
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
